export enum UserRole {
  ADMIN = 'ADMIN',
  USER = 'USER',
}

export type User = {
  photoURL: string;
  phoneNumber: string;
  emailVerified: boolean;
  email: string;
  displayName: string;
  uid: string;
  role: UserRole;
  disabled?: boolean;
};

export type LoginUser = {
  user: User;
  access_token: string;
};

export type LoginValues = {
  email: string;
  password: string;
};

export type RegisterValues = {
  name: string;
  email: string;
  password: string;
  disabled: boolean;
};

export type UpdateUserInput = {
  uid?: string;
  email?: string;
  display_name?: string;
  phone_number?: string;
  photo_url?: string;
  photo?: File;
  disabled?: boolean;
  plan_id?: string;
};

export type UpdateUserResponse = {
  user: User;
};
